module.exports = __webpack_public_path__ + "static/img/activity.33c7361.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/activity.png
// module id = xnBA
// module chunks = 34